import type { Country } from "../Country.js";
import { type EuCountry, euCountries } from "./euCountries.js";

export function isCountryInEuropeanUnion(country: Country | (string & {}) | "outsideEu"): country is EuCountry {
	return country !== "outsideEu" && euCountries.some((euCountry) => euCountry === country);
}
